import { useQuery } from "@tanstack/react-query";
import { useFirebaseUser } from "../../../useFirebaseUser.shared";
import { useSellarCurrentBusiness } from "../../../useSellarCurrentBusiness.shared";
import {
  apiV2AssertResponse,
  ApiV2QueryOptions,
  apiV2Request,
  getDefaultQueryOptionsV2,
} from "../apiV2Request";
import { ServerStateKeys } from "../ServerStateKeys";
import {
  TwoBillingPeriodSummaryParametersType,
  TwoBillingPeriodSummaryResponseType,
} from "@sellar-io/api-v2/types";

export const useTwoBillingPeriodSummary = <
  TData = TwoBillingPeriodSummaryResponseType,
>(
  params: TwoBillingPeriodSummaryParametersType,
  options?: ApiV2QueryOptions<TData>,
) => {
  const { business } = useSellarCurrentBusiness();
  const { user } = useFirebaseUser();

  return useQuery({
    queryKey: [
      user?.uid,
      business?.id,
      ServerStateKeys.twoBillingPeriodSummary,
      params,
    ],
    queryFn: () =>
      apiV2Request({
        user,
        business,
        method: "get",
        path: `sellar-credit-management/two/billing-period-summary`,
        params,
      }).then((data) => apiV2AssertResponse<TData>(data).data),
    ...getDefaultQueryOptionsV2({
      context: { scope: "business", user, business: business },
      options: { ...options },
    }),

    /** Prevent refetching for 30 minutes */
    staleTime: 30 * 60 * 1000, // 30 minutes

    /** Keep cached for an hour */
    gcTime: 60 * 60 * 1000,
  });
};
